import { render, staticRenderFns } from "./ApplyResult.vue?vue&type=template&id=16b0d263&scoped=true&"
import script from "./ApplyResult.vue?vue&type=script&lang=js&"
export * from "./ApplyResult.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/applyResult.less?vue&type=style&index=0&id=16b0d263&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0d263",
  null
  
)

export default component.exports